<div class="container-home">

<div
    class="container-page"
    [class.container-page--welcome]="showWelcome()"
    [class.container-page--resizing]="resizingList()"
    [style.--list-width]="listWidthRem() + 'rem'">

    <!-- Primeiro uso (feed vazio sem busca/filtro): canvas de boas-vindas no
         lugar dos dois painéis — some sozinho quando o feed ganhar itens -->
    @if (showWelcome()) {
        <order-welcome animate.enter="welcome-enter" />
    }
    @else {
        <div class="container-list-orders">
            <!-- Feed unificado (beta da flag `unified_feed`) ou lista clássica -->
            @if (unifiedFeedEnabled()) {
                <feed-list />
            }
            @else {
                <order-list />
            }

            <!--
                Divisor da coluna. Fica sobre o vão entre os painéis (por isso o
                `right` negativo) e é um `separator` de verdade: dá para ajustar
                pelo teclado, e o duplo clique devolve a largura padrão.
            -->
            <div
                class="list-resizer"
                role="separator"
                tabindex="0"
                aria-orientation="vertical"
                [attr.aria-label]="'order.main.resizeList' | translate"
                [attr.aria-valuenow]="listWidthRem()"
                [attr.aria-valuemin]="listWidthMin"
                [attr.aria-valuemax]="listWidthMax"
                (pointerdown)="onResizeStart($event)"
                (keydown)="onResizeKey($event)"
                (dblclick)="onResizeReset()">
            </div>
        </div>

        @if (orderMainService.currentOrder() == null) {
            <div class="container-empty-order">
                <!-- Nada SELECIONADO, com a lista cheia ao lado. Não é o primeiro uso
                     (esse é o `order-welcome`): aqui a tela oferece o próximo passo em
                     vez de avisar que não há nada aberto. -->
                <order-empty (startWithIa)="openIaWizard($event)" />
            </div>
        }
        @else {
            <div class="container-details-order">
                <order-details />
            </div>
        }
    }

    @if (iaWizardOpen()) {
        <!-- "Começar" da tela sem seleção: tipo → modelo → contexto, e o editor abre
             no modo IA com o contexto como primeira mensagem. -->
        <create-with-ia-wizard
            [initialPrompt]="iaWizardPrompt()"
            (close)="iaWizardOpen.set(false)" />
    }

    @if (!featureFlagController.isBlocked('generate_with_ia')) {
        <!--
            A bolinha é FLUTUANTE (não pertence a nenhum serviço), então abre
            sempre SEM destino: o chat pergunta "onde salvar?", com a opção de
            documento avulso. O card "Criar com IA" do modal "+ Novo" abre esta
            mesma bolinha; só a welcome ("Novo documento → Usar o chat") entra já
            com destino definido (standalone). Ver `_chatOpenEffect` na page.
        -->
        <ia-chat-launcher-bubble
            #iaBubble
            class="ia-chat-floating"
            [orderId]="null"
            [standalone]="chatStandalone()"
            [initialDraft]="chatInitialDraft()"
            [hideLauncher]="showEmptySelection()"
            (closed)="chatStandalone.set(false)"
            (concluded)="onChatConcluded()"
        />
    }
</div>

</div>

<!--
    Apresentação da novidade. Abre SOZINHA na primeira entrada de quem ainda não
    vinculou, e fechar marca como visto para sempre. Modal em vez de faixa
    porque a faixa no topo da home passava despercebida.
-->
@if (showWhatsappIntro()) {
    <channel-link [showIntro]="true" (onClose)="closeWhatsappIntro()" />
}

<!-- Apresentação dos apps de IA (MCP): mesmo padrão, para quem ainda não conectou nenhum -->
@if (showMcpIntro()) {
    <mcp-intro (onClose)="closeMcpIntro()" />
}
